import React, { Component } from "react";
import { connect } from 'react-redux';
import taxpayer from '../../Actions/taxpayer';
const { calculateVolumeProcess } = taxpayer.actions;

class IssuingVolumeMonthly extends Component {

    constructor(props) {
        super(props);
        this.makeRequest = this.makeRequest.bind(this);
    }

    render() {
        let { issuingVolumeMonthly, receivingVolumeMonthly, createdDate, updatedDate } = this.props.data;
        if (issuingVolumeMonthly || receivingVolumeMonthly) {
            return <div className="blue-text">Calculado correctamente</div>;
        }

        if (issuingVolumeMonthly === 0 && createdDate === updatedDate) {
            return <div className="blue-text">Calculando volumen</div>;
        }

        return (
            <div className="center-flex-horizontal">
                <button className="custom-secondary-button" onClick={this.makeRequest}>
                    Calcular
                </button>
            </div>
        );
    }

    makeRequest() {
        let { taxId } = this.props.data;
        this.props.calculateVolumeProcess({ taxId, query: this.props.query });
    }

};
const mapStateToProps = state => {
    return {
        taxpayerVolume: state.taxpayer.taxpayerVolume,
    };

};

const mapDispatchToProps = dispatch => {
    return {
        calculateVolumeProcess(data) {
            dispatch(calculateVolumeProcess(data))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssuingVolumeMonthly);